import React, { useEffect, useState } from 'react'
import PouchDB from 'pouchdb'
import { format } from 'date-fns';
import { de } from 'date-fns/locale'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import usePersons from '../hooks/usePersons';
import { useMostRecentActions } from '../hooks/useMostRecentActions';
import { actionTypeLabels } from './machine-action'
import { attachUserInfoToActions } from '../utils/users';
import { timeAgo } from '../utils/time';
import { Action } from './machine-action';

export interface RecentWorkStatusProps {
  machineId: string;
  customerId: string;
  routeKey?: string;
}

export const RecentWorkStatus: React.FC<RecentWorkStatusProps> = props => {
  const [refreshKey, setRefreshKey] = useState<string>(props.routeKey || '')
  const [timeSpan, setTimeSpan] = useState<number>(3)
  const [allActions, setAllActions] = useState<Action[]>([])
  const { persons, hasLoaded: personsLoaded } = usePersons(props.customerId, `${refreshKey}-${String(timeSpan)}`)

  const { lastActions, hasLoaded: actionsLoaded } = useMostRecentActions(props.customerId, props.machineId, true, refreshKey)

  useEffect(() => {
    const allActionsWithPersonData = attachUserInfoToActions([...lastActions].reverse(), persons)
    setAllActions(allActionsWithPersonData)
  }, [lastActions, persons])

  const handleMarkAsComplete = async (action: Action) => {
    let dbName = `${props.customerId}-${format(new Date(action._id.substring( 12)), 'yyyy-MM')}`
    const db = new PouchDB(dbName)
    let updatedDoc: Action = {
      ...action,
      done: true
    }
    try {
      const response = await db.put(updatedDoc)
      if (response.ok) {
        // force re-run of the hooks
        setRefreshKey(`${refreshKey}-${Date.now()}`)
      }
    } catch (e) {
      console.log(`Could not mark action "${action._id}" as completed:`, e)
    }
  }

  if (personsLoaded && actionsLoaded && allActions.length) {
    return (
      <div className="recent-work-status">
        <h5 className="title is-5 mb-1">Offene Arbeitsaufträge in den letzten {timeSpan} Monaten</h5>
        <div className="table-container">
          <table className="table is-striped is-fullwidth">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Von</th>
                <th>An</th>
                <th>Typ</th>
                <th>Auftrag</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {allActions.map((action, index) => {
                return <tr key={action._id} className="recent-work-item">
                <td>{format(new Date(action._id.substring( 12)), "cccc', den 'dd.MM.yyyy' um 'HH:mm", { locale: de })} ({timeAgo(action._id.substring(12, 31))})</td>
                <td>{action.creatorName ? action.creatorName : '–'}</td>
                <td>{action.assigneeName}</td>
                <td>{action.actionType ? actionTypeLabels[action.actionType] : '–'}</td>
                <td>{action.instruction}</td>
                <td>
                  <button className="button is-success is-outlined mt-1" onClick={() => handleMarkAsComplete(action)}>
                    <span className="icon">
                      <FontAwesomeIcon icon="check" size="sm" />
                    </span>
                    <span>Abhaken</span>
                  </button>
                </td>
            </tr>
          })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  return null
}
